export default __webpack_public_path__ + "CircularCustCapNum-BookItalic.f00dc94ab3d3885370270b2d45267dde.ttf";